import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { withRouter } from '../withRouter';
import { addToCart } from 'actions/cart';
import styles from './GameStyles.module.scss'
import { getAddons } from '../../constants/GameListAdapter';
import basketIcon from '../../images/icons/basketIcon.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import PricingFunctions from '../../common/PricingFunctions';
import kickstarterLogo from 'images/kickstarter-logo.png';
import DotLoader from 'components/Utlility/DotLoader';
import placeHolderCard from 'images/gameStorePreviews/placeholder-card.svg';

class Game extends Component {
    static displayName = Game.name;

    constructor(props) {
        super(props);

        this.state = {
            game: null,
            gameAddons: this.getAddons(),
            price: this.getPrice(),
            oldPrice: this.getPrice(true)
        };

        this.focus = React.createRef();
    }

    isDev() {
        return !process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === 'development';
    }

    getAddons() {
        if (this.props.isTvApp) {
            return [];
        }
        // Get addons that belong to this game (their gameId is in this game's addonIds)
        const gameAddonIds = this.props.game?.addonIds || [];
        return getAddons().filter((a) => gameAddonIds.includes(a.gameId)).map((a) => {
            const owned = a.price === 0 || (this.props.addons && this.props.addons.find(ownedAddon => ownedAddon.code === a.gameId) ? true : false);
            return { ...a, owned }
        });
    }

    componentDidMount() {
        if (this.props.focus) {
            this.focus.current?.focus();
        }
    }

    componentDidUpdate(prevProps) {
        // Update prices if game pricing data changed
        const prevPricing = prevProps.game?.pricing;
        const currentPricing = this.props.game?.pricing;
        const prevCountryCode = prevProps.pricing?.countryCode;
        const currentCountryCode = this.props.pricing?.countryCode;

        if (prevPricing !== currentPricing || prevCountryCode !== currentCountryCode) {
            this.setState({
                price: this.getPrice(),
                oldPrice: this.getPrice(true)
            });
        }
    }

    tryGoToGame(gameId) {
        this.props.room.room.send("StartGame", { gameId });
    }

    clickAddToCart(game) {
        this.props.addToCart(game);
    }

    ownsGame() {
        return this.props.owned;
    }

    getCardStyling() {
        // Use store-specific card for store context, game card for lobby context.
        // Addons conventionally upload only a storeTinyCard (a logo-on-flat-bg
        // thumbnail) and use storeBackgrounds-style art in the storeCard slot, so
        // for addons we prefer storeTinyCard for the card face — falling back to
        // storeCard if that's somehow the only asset present.
        const storeCard = this.props.game?.meta?.storeCard;
        const storeTinyCard = this.props.game?.meta?.storeTinyCard;
        const gameCard = this.props.game?.meta?.gameCard;
        const isAddon = this.props.game?.type === 'Addon';
        const cardImage = this.props.fromLobby
            ? (gameCard || placeHolderCard)
            : ((isAddon ? (storeTinyCard || storeCard) : storeCard) || placeHolderCard);
        return {
            backgroundImage: `url(${cardImage})`
        }
    }

    hasPlaceholderCard() {
        const storeCard = this.props.game?.meta?.storeCard;
        const storeTinyCard = this.props.game?.meta?.storeTinyCard;
        const gameCard = this.props.game?.meta?.gameCard;
        const isAddon = this.props.game?.type === 'Addon';
        if (this.props.fromLobby) return !gameCard;
        return isAddon ? !(storeTinyCard || storeCard) : !storeCard;
    }

    getCardPriceBannerStyling() {
        return {
            background: this.props.game.meta.cardPriceColour
        }
    }

    getButtonStyling(opacity = 1) {
        return {
            background: this.props.game.meta.storeAccentColour
        }
    }

    getBannerStyling() {
        return {
            background: this.props.game.meta.bannerColour ? this.props.game.meta.bannerColour : this.props.game.meta.storeAccentColour
        }
    }

    clickGameCard = (e) => {
        e.preventDefault();
        if (this.props.onClickOverride && !this.props.game?.kickstarter) {
            this.props.onClickOverride(this.props.game)
            return;
        }
        if (this.props.fromLobby) {
            this.props.loadGameMenu(this.props.game);
        } else {
            this.props.navigate(this.props.game.storeSlug)
        }
    }

    clickInfoButton = (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.clickGameCard(e);
    }

    getPrice(old) {
        let countryCode = this.props.pricing.countryCode;
        let pricing = PricingFunctions.getGamePricing(countryCode, this.props.game, old);
        // Don't return old price if it's 0 or doesn't exist
        if (old && (!pricing || !pricing.raw || pricing.raw <= 0)) {
            return null;
        }
        return pricing?.display;
    }

    goToAddon(g) {
        if (g.owned) this.props.loadGameMenu(this.props.game);
        else this.props.navigate(g.storeSlug);
    }
    getAddonText() {
        const ownedCount = this.state.gameAddons.filter(a => a.owned).length;
        const availableCount = this.state.gameAddons.length - ownedCount;
        let text = "Add-ons: "
        text += ownedCount !== 0 ? `${ownedCount} owned` : "";
        if (ownedCount > 0 && availableCount > 0) text += ", "
        text += availableCount !== 0 ? `${availableCount} available` : "";
        return text;
    }

    renderAddonList() {
        const addons = this.state.gameAddons.map((a) => {
            // Use appropriate tinyCard based on context - no fallback
            const tinyCardImage = this.props.fromLobby
                ? a.meta?.tinyCard
                : a.meta?.storeTinyCard;
            return <div className={styles.addonCard} key={a.addonId}>
                {/*{a.owned && <FontAwesomeIcon icon={faCircleCheck} target="_blank" />}*/}
                <img className={`${a.owned && styles.owned}`} src={tinyCardImage} onClick={() => this.goToAddon(a)} alt="addon-card" />
            </div>
        });
        if (addons.length > 0) {
            return <>
                <div className={styles.addonList} style={this.getButtonStyling()}>
                    {addons}
                </div>
            </>
        } else {
            return null;
        }
    }

    getAdditionalCardStyles() {
        if (this.props.game?.gameId === "playing_with_fire") {
            return {
                width: '50%',
                objectFit: 'cover',
                imageRendering: 'pixelated',
                position: 'absolute',
                top: '50%',
            }
        } else if (this.props.game?.gameId === "dond") {
            return {
                width: "75%"
            }
        }
    }

    getAdditionalAccent() {
        if (this.props.game?.name === "Playing With Fire") {
            let styles = {
                position: 'absolute',
                left: '27%',
                bottom: '10%',
                height: '40%',
                transform: 'translateX(-50%)',
                imageRendering: 'pixelated'
            }
            return <img src={this.props.game?.meta?.animatedAccent} style={styles} />
        }
    }

    onAddToCart(game) {
        if (this.props.onAddToCartOverride) {
            this.props.onAddToCartOverride(game)
            return;
        }
        this.clickAddToCart(this.props.game)
    }

    openInNewTab(url) {
        window.open(url, '_blank').focus();
    }

    onBuyNow(game) {
        if (this.props.onBuyNow) this.props.onBuyNow(game)
    }

    render() {
        return (
            this.props.game &&
            (
                !this.props.isInApp || //TODO: move to game list data (dont hard code filters)
                (
                    this.props.game.iosGameID !== "game.city.poker" &&
                    this.props.game.androidGameID !== "game.city.poker"
                )
            ) &&
            <div className={`${styles.gameCardWrapper} ${this.props.fromLobby && styles.lobby} ${this.props.fromLobby && !this.props.supported && styles.unsupported} ${!this.props.fromLobby && this.props.game.status === 'hidden' && styles.hiddenInStore}`}>

                {/* Slide-out addon list disabled in favour of new owned-addon badges. */}
                {/* {this.props.fromLobby && this.renderAddonList()} */}
                <div className={styles.gameCard}>
                    <div onClick={this.clickGameCard} className={styles.clickOverlay} tabIndex={this.props.tabIndex} ref={this.focus} />
                    {
                        this.isDev() && !this.props.fromLobby && this.props.game.status === 'hidden' &&
                        <div className={styles.devBadges}>
                            <div className={styles.hiddenBadge}>HIDDEN</div>
                        </div>
                    }
                    {
                        this.props.gameVotes > 0 &&
                        <div className={styles.votesCounter} style={this.getCardPriceBannerStyling()}><span>{this.props.gameVotes}</span></div>
                    }
                    <div className={`${styles.gameCardBackground} ${this.props.fromLobby && styles.rounded}`} style={this.getCardStyling()}>
                        {/* Logo is now baked into gameCard image */}
                        {
                            this.hasPlaceholderCard() && this.props.fromLobby &&
                            <div className={styles.placeholderName}>{this.props.game.name}</div>
                        }
                        {
                            this.getAdditionalAccent()
                        }
                        {
                            //    !this.props.fromLobby && this.props.game?.price &&
                            //    <div className={styles.priceBanner} style={this.getCardPriceBannerStyling()}><span>{this.getPrice() || <DotLoader size="small" variant="dark" />}</span></div>
                        }
                        {
                            this.props.game.gameInfo.banner && !this.props.fromLobby &&
                            <div className={styles.banner} style={this.getBannerStyling()}>{this.props.game.gameInfo.banner}</div>
                        }
                        {
                            this.props.game.gameInfo.lobbyBanner && this.props.fromLobby &&
                            <div className={styles.banner} style={this.getBannerStyling()}>{this.props.game.gameInfo.lobbyBanner}</div>
                        }
                        {/* Bottom-left "Add-ons: X owned, Y available" notch hidden in favour of new owned-addon badges. */}
                        {/* {
                            this.props.fromLobby && this.state.gameAddons.length > 0 && !this.props.hideAddons &&
                            <div className={styles.availableAddons} style={this.getButtonStyling()}>{this.getAddonText()}</div>
                        } */}
                        {
                            // Owned-addon badges anchored at the bottom-left of the
                            // lobby card. Clicking opens the parent's start-game
                            // popup — they already own the addon so there's nothing
                            // to buy here, just a visual cue that the pack is active.
                            this.props.fromLobby && this.state.gameAddons.some(a => a.owned) && (
                                <div className={styles.ownedAddonBadgeRow}>
                                    <span className={styles.ownedAddonLabel}>ADD-ONS:</span>
                                    {this.state.gameAddons.filter(a => a.owned).map(a => (
                                        <img
                                            key={a.gameId}
                                            src={a.meta?.tinyCard || a.meta?.storeTinyCard}
                                            alt={a.name}
                                            title={a.name}
                                            className={styles.ownedAddonBadge}
                                            onClick={(e) => { e.stopPropagation(); this.props.loadGameMenu && this.props.loadGameMenu(this.props.game); }}
                                        />
                                    ))}
                                </div>
                            )
                        }
                        {
                            // Use appropriate corner banner based on context
                            // Store: storeCornerBanner, Lobby: lobbyCornerBanner
                            (() => {
                                const banner = this.props.fromLobby
                                    ? this.props.game.gameInfo?.lobbyCornerBanner
                                    : this.props.game.gameInfo?.storeCornerBanner;
                                return banner && banner.text && (
                                    <div className={styles.cornerBanner} style={{ background: banner.colour }}>
                                        {banner.text}
                                    </div>
                                );
                            })()
                        }
                        {
                            !this.props.fromLobby &&
                            <button className={styles.infoBtn} onClick={this.clickInfoButton} aria-label="Game info">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                    <circle cx="12" cy="12" r="10" />
                                    <line x1="12" y1="16" x2="12" y2="12" />
                                    <line x1="12" y1="8" x2="12.01" y2="8" />
                                </svg>
                            </button>
                        }
                    </div>
                    {
                        !this.props.fromLobby &&
                        <React.Fragment>
                            <div className={`${styles.cardDescriptionBox} p-3`}>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h4>{this.props.game.name}</h4>
                                    <div className="d-flex align-items-center gap-2">
                                        {this.state.oldPrice && <h4 className="text-decoration-line-through m-0 fs-6" style={{ color: '#c60d0d' }}>{this.state.oldPrice}</h4>}
                                        <h4 className="m-0" style={{ color: '#000000' }}>{this.state.price}</h4>
                                    </div>
                                </div>
                                <p>{this.props.game.description}</p>
                            </div>
                            {
                                this.props.isTvApp ?
                                    <h4 className={`${styles.addToCartBox} p-3`}>Buy via another device</h4>
                                    :
                                    this.props.game?.kickstarter ?
                                        <div className={styles.buttons}>
                                            <button onClick={() => { this.openInNewTab("https://www.kickstarter.com/projects/1169339123/deal-or-no-deal-the-party-game-for-your-tv") }} className={`${styles.button} ${styles.addToCart} p-3 ${styles.kickstarter}`}>
                                                <h6>FIND OUT MORE ON</h6>
                                                <img src={kickstarterLogo} className={styles.kickstarterLogo}></img>
                                            </button>
                                        </div>
                                        :
                                        <>
                                            {
                                                this.props.isInApp &&
                                                <div className={styles.AppCautionContainer}>
                                                    <h1>Please note: you're buying this game for the host</h1>
                                                    <h3>{this.props.hostUser?.sub}</h3>
                                                </div>
                                            }

                                            <div className={styles.buttons}>
                                                {this.props.showBuyNow &&
                                                    <button onClick={() => { this.onBuyNow(this.props.game) }} className={`${styles.button} ${styles.buyNow} p-3`}>
                                                        <h4>{this.props.buyNowText ?? "Buy Now"}</h4>
                                                    </button>
                                                }
                                                {this.props.showAddToCart &&
                                                    <button onClick={() => { this.onAddToCart(this.props.game) }} className={`${styles.button} ${styles.addToCart} ${this.props.smallCartButton && styles.miniButton} p-3`}>
                                                        {this.props.smallCartButton ?
                                                            < img src={basketIcon} alt="" width="25" height="29"></img>
                                                            : <h4>{this.props.addToCartText ?? "Add To Cart"}</h4>
                                                        }
                                                    </button>
                                                }
                                            </div>
                                        </>

                            }
                        </React.Fragment>
                    }
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
        pricing: state.pricing,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (game) => {
            dispatch(addToCart(game))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Game));
